import * as type from './WheelPackageActionType'



export const asyncCall = (ownProps)=>({type:type.OPEN_MODAL_AND_ASYNC_CALL,payload:ownProps});
export const closeModal = ()=>({type:type.CLOSE_MODAL});